export const SymptomCheckerCallback = {
	Emergency: 'sos',
	CallingDoctor: 'pnd',
	Telemed: 'tmp',
	Chat: 'chat',
	CallCC: 'call_the_contact_center',
	GoBack: 'back_to_lk',
};

// TODO: Почему это здесь? Используйте модуль known-rgs-business-event-code
export const RgsApiBusinessEventCode = {
	IsSick: 'Dms_Nav_ClickIAmSick',
	Emergency: 'Dms_Nav_ShowCallEmergencyPopup',
	EmergencyTel: 'Dms_Nav_ClickCallEmergencyPhone',
	CallingDoctor: 'Dms_Nav_ShowCallingDoctorPopup',
	Telemed: 'Dms_Nav_ShowTelemedicinePopup',
	TelemedTab: 'Dms_Nav_GoToTelemedicine',
	Chat: 'Dms_Nav_OpenChat',
};

export const SOURCE_PARAM = 'symptomChecker';

export const SOURCE_PARAM_KEY = 'rgstm_source';
